import { Group } from "../../group";
import { Children, forwardRef } from "react";
import { augmentElement, cssModule, mergeProps, normalizeSize, omitProps, slot } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { useFieldInputProps } from "../../field";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";

/* eslint-disable sort-keys, sort-keys-fix/sort-keys-fix */
const Gap = {
  "horizontal": {
    "sm": 3,
    "md": 4
  },
  "vertical": {
    "sm": 2,
    "md": 3
  }
};
/* eslint-enable sort-keys, sort-keys-fix/sort-keys-fix */

export function InnerButtonGroup(props) {
  const [fieldProps, isInField] = useFieldInputProps();
  const {
    align,
    as = DefaultElement,
    children,
    disabled,
    fluid,
    forwardedRef,
    orientation = "horizontal",
    size,
    ...rest
  } = mergeProps(props, omitProps(fieldProps, ["fluid"]));
  const orientationValue = useResponsiveValue(orientation);
  const sizeValue = useResponsiveValue(size);
  return /*#__PURE__*/_jsx(Group, { ...mergeProps(rest, {
      align,
      as,
      className: cssModule("o-ui-button-group", isInField && "in-field"),
      fluid,
      gap: Gap[orientationValue][normalizeSize(sizeValue)],
      orientation,
      ref: forwardedRef,
      role: !isInField ? "group" : undefined
    }),
    children: Children.toArray(children).filter(x => x).map(x => {
      return augmentElement(x, {
        disabled,
        fluid,
        size: sizeValue
      });
    })
  });
}
InnerButtonGroup.defaultElement = DefaultElement;
export const ButtonGroup = slot("button-group", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerButtonGroup, { ...props,
  forwardedRef: ref
})));